import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getErrorMessage } from '@juvare/common-web-ui/utils';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useInboxClient, useInboxNotification } from '../../hooks';
import { NotificationAttachmentList } from '../NotificationAttachments';
import { NotificationPhinDetails } from '../NotificationPhinDetails';
import { NotificationResponse } from '../NotificationResponse';
import { InboxNotificationHeader } from './components';
export const InboxNotificationView = ({ id, onReload, onCloseDialog }) => {
    const { data, isLoading, error, mutate } = useInboxNotification(id);
    const inbox = useInboxClient();
    const boxRef = React.useRef();
    React.useEffect(() => {
        if (boxRef.current && !!(data === null || data === void 0 ? void 0 : data.id)) {
            boxRef.current.focus();
        }
    }, [data === null || data === void 0 ? void 0 : data.id]);
    React.useEffect(() => {
        if (!isLoading && !error && (data === null || data === void 0 ? void 0 : data.id) && !(data === null || data === void 0 ? void 0 : data.read)) {
            inbox
                .markAsRead([data.id])
                .then(() => mutate())
                .then(() => onReload(false))
                .catch(handleErrorSnackbar);
        }
    }, [isLoading, error, data === null || data === void 0 ? void 0 : data.id, data === null || data === void 0 ? void 0 : data.read]);
    return (React.createElement(Box, { ref: boxRef, tabIndex: 0 },
        React.createElement(InboxNotificationHeader, { data: data, onReload: onReload, onRefresh: () => mutate().finally(() => undefined), onCloseDialog: onCloseDialog }),
        !data && isLoading && (React.createElement(Box, { sx: { px: 2, py: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(CircularProgress, null))),
        !data && error && (React.createElement(Box, { p: 2, pb: 8 },
            React.createElement(Alert, { severity: 'error' }, getErrorMessage(error)))),
        data && (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, p: 2, pt: 0 } },
            React.createElement(Typography, { component: 'div', variant: 'body2', sx: {
                    p: 2,
                    '&>div>:first-child/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */': { marginTop: 0 },
                    '&>div>:last-child': { marginBottom: 0 },
                }, dangerouslySetInnerHTML: { __html: data.htmlMessage } }),
            (data === null || data === void 0 ? void 0 : data.attachments) && React.createElement(NotificationAttachmentList, { notificationId: data.id, attachments: data.attachments }),
            (data === null || data === void 0 ? void 0 : data.additionalData) && React.createElement(NotificationPhinDetails, { additionalData: data.additionalData }),
            (data === null || data === void 0 ? void 0 : data.responseOptions) && React.createElement(NotificationResponse, { notification: data, onReload: onReload })))));
};
